import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchCategoryById } from "./dailySentenceService";
import "./DailySentenceListPage.css";

const levelColor = (l) => {
  const map = { EASY: "#4caf50", MEDIUM: "#ff9800", HARD: "#e91e63" };
  return map[l?.toUpperCase()] || "#999";
};

const DailySentenceCategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      console.log("[DailySentenceCategoryPage] Loading category id:", categoryId);
      setLoading(true);
      const res = await fetchCategoryById(categoryId);
      if (res.status === 200 && res.data?.status) {
        console.log("[DailySentenceCategoryPage] Category loaded:", res.data.data?.title, "sentences:", res.data.data?.sentences?.length || 0);
        setCat(res.data.data);
      } else {
        console.error("[DailySentenceCategoryPage] Load failed:", res.status, res.message);
      }
      setLoading(false);
    };
    load();
  }, [categoryId]);

  if (loading) return (<><Navbar /><div className="ds-cat-page"><p className="ds-loading">Loading...</p></div><Footer /></>);

  if (!cat) return (
    <>
      <Navbar />
      <div className="ds-cat-page">
        <p className="ds-loading">Category not found.</p>
        <button className="ds-back" onClick={() => navigate("/study/daily-sentences")}>← Back</button>
      </div>
      <Footer />
    </>
  );

  return (
    <>
      <Navbar />
      <div className="ds-cat-page">
        <button className="ds-back" onClick={() => navigate("/study/daily-sentences")}>
          ← Back to Daily Sentences
        </button>

        <div className="ds-cat-hero">
          <span className="ds-cat-icon">{cat.icon || "📂"}</span>
          <h1 className="ds-cat-title">{cat.title}</h1>
          {cat.description && <p className="ds-cat-desc">{cat.description}</p>}
        </div>

        {cat.youtubeVideoUrl && (
          <div className="ds-video-card">
            {cat.videoTitle && <h3 className="ds-video-title">🎬 {cat.videoTitle}</h3>}
            {cat.videoDescription && <p className="ds-video-desc">{cat.videoDescription}</p>}
            <div className="ds-video-wrapper">
              <iframe
                src={cat.youtubeVideoUrl.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/")}
                title={cat.videoTitle || cat.title}
                allowFullScreen
                frameBorder="0"
              />
            </div>
          </div>
        )}

        {(!cat.sentences || cat.sentences.length === 0) ? (
          <p className="ds-loading">No sentences in this category yet.</p>
        ) : (
          <div className="ds-sentence-list">
            {cat.sentences.map((s) => (
              <div key={s.id} className="ds-sentence-item" onClick={() => navigate(`/study/daily-sentences/${s.id}`)}>
                <div className="ds-sentence-info">
                  <h3 className="ds-sentence-title">{s.title}</h3>
                  {s.description && <p className="ds-sentence-desc">{s.description}</p>}
                </div>
                <span className="ds-sentence-level" style={{ background: levelColor(s.level) }}>
                  {s.levelDisplayName || s.level}
                </span>
                <span className="ds-sentence-arrow">→</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default DailySentenceCategoryPage;
